import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import OfferIcon from '../../../icons/Offer'
import Loader from '../Loader'
import {
  pushTopDestinationsClick,
  pushSearchAutocomplete,
  pushSearchOfferBody,
  pushSearchOfferHeader,
} from '../../../../helpers/gtm'
import './suggestions.scss'

const Suggestions = ({
  TitleIcon,
  title,
  ItemIcon,
  data,
  onChooseKeyword,
  className,
  isOffers,
  hotels,
  titleEn,
}) => (
  <div className={cn('suggestions', className)}>
    {TitleIcon && title && (
      <div
        className="suggestions-header"
        onClick={() => {
          if (isOffers) {
            onChooseKeyword(
              Object.keys(hotels).map(key => hotels[key].code).join(','),
              false,
              false,
              false,
              false,
            )
            if (titleEn) {
              pushSearchOfferHeader(titleEn)
            }
          }
        }}
        role="button"
        onKeyUp={() => {}}
        tabIndex="0"
      >
        {typeof TitleIcon === 'function' ? (
          <TitleIcon className="suggestions-header__icon" />
        ) : (
          <img src={TitleIcon} alt="" />
        )}
        <div className="suggestions-header__title">
          {title}
        </div>
      </div>)
    }
    <div className="suggestions-body">
      {isOffers ? (
        Object.keys(hotels).map((key, i) => (
          <div
            key={`${hotels[key].title}_${i + 1}`}
            className="suggestions-body-item"
            onClick={() => onChooseKeyword(`${hotels[key].code}`, false, false, false, false, hotels[key].title, pushSearchOfferBody(`${hotels[key].code}`))}
            role="button"
            onKeyUp={() => {}}
            tabIndex="0"
          >
            <div className="suggestions-body-item__icon">
              <OfferIcon />
            </div>
            <div className="suggestions-body-item__name">
              {hotels[key].title}
            </div>
          </div>
        ))
      ) : (
        <React.Fragment>
          {data.loading && <Loader />}
          {data.items.length > 0
            && data.items.map((item, key) => (
              <div
                key={`${item.name}_${key + 1}`}
                className="suggestions-body-item"
                onClick={() => {
                  if (item.source === 'geomaj') {
                    pushSearchAutocomplete(item.name)
                  } else {
                    pushTopDestinationsClick(item.nameEn || item.name)
                  }
                  onChooseKeyword(item.name, item.source, item.type, item.id, false, item.name)
                }}
                role="button"
                onKeyUp={() => {}}
                tabIndex="0"
              >
                <div className="suggestions-body-item__icon">
                  {ItemIcon ? (
                    <ItemIcon />
                  ) : (
                    <img src={item.icon} alt={item.alt} title={item.title} />
                  )}
                </div>
                <div className="suggestions-body-item__name">
                  {item.name}
                </div>
              </div>
            ))
          }
        </React.Fragment>
      )}
    </div>
  </div>
)

Suggestions.defaultProps = {
  data: {
    items: [],
    loading: false,
  },
  TitleIcon: null,
  title: null,
  titleEn: null,
  ItemIcon: null,
  className: null,
  isOffers: false,
  hotels: {},
}

Suggestions.propTypes = {
  TitleIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  title: PropTypes.string,
  titleEn: PropTypes.string,
  ItemIcon: PropTypes.func,
  data: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string,
        name: PropTypes.string.isRequired,
        alt: PropTypes.string,
        title: PropTypes.string,
      }),
    ),
    loading: PropTypes.bool,
  }),
  onChooseKeyword: PropTypes.func.isRequired,
  className: PropTypes.string,
  isOffers: PropTypes.bool,
  hotels: PropTypes.instanceOf(Object),
}

export default Suggestions
